import { useTask } from '~/contexts/TaskContext'

export function useTaskBlock() {
  const { messages } = useTask()
  const taskMessage = messages.find(message => message.blocks?.[0]?.type === 'task')
  return taskMessage?.blocks?.[0]
}
